// API Configuration - Auto-generated by deployment script
const config = {
  // BFF (Backend for Frontend) URL - can be switched between MockBFF and AWS API Gateway
  BFF_URL: process.env.REACT_APP_AWS_API_GATEWAY_URL || 'https://2jh7sj7uxf.execute-api.ap-northeast-3.amazonaws.com/prod',
  
  // Backend URL (for reference, not used directly by UI)
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001',
  
  // Environment
  ENV: process.env.REACT_APP_ENV || 'prod',
  
  // Available BFF endpoints for easy switching
  BFF_ENDPOINTS: {
    mock: 'http://localhost:3002',
    prod: process.env.REACT_APP_AWS_API_GATEWAY_URL || 'https://2jh7sj7uxf.execute-api.ap-northeast-3.amazonaws.com/prod'
  },
  
  // API endpoints
  endpoints: {
    auth: {
      login: '/api/auth/login',
      logout: '/api/auth/logout'
    },
    products: {
      list: '/api/products',
      update: '/api/products'
    }
  }
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  return `${config.BFF_URL}${endpoint}`;
};

// Helper function to get BFF health check URL
export const getBffHealthUrl = () => {
  return `${config.BFF_URL}/health`;
};

// Helper function to switch BFF endpoints
export const switchBff = (bffType) => {
  if (config.BFF_ENDPOINTS[bffType]) {
    config.BFF_URL = config.BFF_ENDPOINTS[bffType];
    console.log(`🔄 Switched to ${bffType} BFF: ${config.BFF_URL}`);
    return config.BFF_URL;
  } else {
    console.error(`❌ Unknown BFF type: ${bffType}`);
    return null;
  }
};

// Helper function to get current BFF type
export const getCurrentBffType = () => {
  for (const [type, url] of Object.entries(config.BFF_ENDPOINTS)) {
    if (config.BFF_URL === url) {
      return type;
    }
  }
  return 'custom';
};

// Helper function to check BFF health
export const checkBffHealth = async (bffUrl = config.BFF_URL) => {
  try {
    const response = await fetch(`${bffUrl}/health`);
    const data = await response.json();
    return { healthy: true, data };
  } catch (error) {
    return { healthy: false, error: error.message };
  }
};

export default config;
